/* eslint-disable react/forbid-prop-types */
import React, {
  useEffect, useState,
} from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import InventorySelector from '../../../recoil/cashout/InventorySelector';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';
import ClaimRewardsResultAtom from '../../../recoil/cashout/ClaimRewardsResultAtom';
import useCatalogAPI from '../../api/CatalogAPI';

import CashoutCatalogPackages from './CashoutCatalogPackages';
import { filterByInventory } from '../../helpers/ProductUtils';

import CashoutModal from './modals/CashoutModal';
import Loading from '../../general/Loading';
import { isTaxAccountAccepted } from './TaxStatusResolver';

export default function CashoutContent({
  payAccount,
  kycAccount,
  taxAccount,
  onRefresh,
}) {
  const catalogAPI = useCatalogAPI();

  const config = useRecoilValue(ClientSideConfigSelector);
  const claimRewardsResult = useRecoilValue(ClaimRewardsResultAtom);
  const {
    live: {
      claimReward: {
        categories: {
          cashout: cashoutCurrency,
        },
      } = {},
    } = {},
  } = config || {};

  const currency = cashoutCurrency.toUpperCase();
  const inventory = useRecoilValue(InventorySelector);

  const [packages, setPackages] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showCashoutModal, setShowCashoutModal] = useState(false);

  const isAccountAccepted = isTaxAccountAccepted(taxAccount);

  useEffect(() => {
    let isMounted = true;

    const fetchCatalog = async () => {
      const catalog = await catalogAPI.fetchCashoutCatalog(currency);
      if (isMounted) {
        setPackages(filterByInventory(catalog, inventory));
      }
    };

    fetchCatalog();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency, inventory, claimRewardsResult.updatedAt]);

  const handleSelectPackage = (pkg) => {
    if (!isAccountAccepted) {
      return;
    }

    setSelectedPackage(pkg);
    setShowCashoutModal(true);
  };

  if (!payAccount || !kycAccount || !taxAccount) {
    return <Loading />;
  }

  // when the product catalog is loading, we want to show the loading state
  if (!packages) {
    return <Loading />;
  }

  return (
    <div>
      <CashoutCatalogPackages
        packages={packages}
        disabled={!isAccountAccepted}
        onClick={(pkg) => {
          handleSelectPackage(pkg);
        }}
      />

      {showCashoutModal && (
        <CashoutModal
          kycAccount={kycAccount}
          payAccount={payAccount}
          selectedPackage={selectedPackage}
          onRefresh={async () => {
            await onRefresh();
          }}
          onClose={() => {
            setShowCashoutModal(false);
          }}
        />
      )}
    </div>
  );
}

CashoutContent.propTypes = {
  payAccount: PropTypes.object,
  kycAccount: PropTypes.object,
  taxAccount: PropTypes.object,
  onRefresh: PropTypes.func.isRequired,
};
CashoutContent.defaultProps = {
  payAccount: null,
  kycAccount: null,
  taxAccount: null,
};
